export default __webpack_public_path__ + "static/media/icon_home_top_privacy.cb54960c.svg";